import axios from '../../utils/axios';

export const getUserStatsThunk = async (_, thunkApi) => {
  try {
    const { connectedAccount, chainId, contract } = thunkApi.getState().user;
    const res = await axios.get('/stats', {
      params: {
        chainId,
        connectedAccount,
        contract,
      },
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};
